import { Globe, MapPin } from 'lucide-react';

const NetworkSection = ({ content, images }) => {
  const extra = content?.extra_fields || {};
  const cities = extra.cities || ['Paris', 'Lyon', 'Marseille', 'Bordeaux', 'Lille', 'Dijon'];

  return (
    <section
      id="network"
      data-testid="network-section"
      className="py-24 lg:py-32 bg-[#1e3a8a] text-white relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37] rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-white/10 text-[#D4AF37] text-sm font-inter font-medium tracking-wide uppercase rounded-full mb-6">
              {extra.badge_text || 'Dimension nationale'}
            </span>
            
            <h2 className="font-playfair text-4xl lg:text-5xl font-bold mb-6">
              {content?.title || 'Réseau national'}
            </h2>
            
            <div className="w-20 h-1 bg-gradient-to-r from-[#D4AF37] to-white/50 mb-8" />
            
            <p className="text-lg text-white/80 font-inter leading-relaxed mb-6">
              {content?.subtitle || 'Membre du Réseau des Places Financières de France'}
            </p>
            
            <p className="text-white/70 font-inter leading-relaxed mb-8">
              {content?.content || 'Cette appartenance nous permet de partager les bonnes pratiques et de renforcer notre action en faveur du développement économique.'}
            </p>

            {/* Features */}
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#D4AF37] rounded flex items-center justify-center flex-shrink-0">
                  <Globe className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-inter font-medium mb-1">
                    {extra.feature1_title || 'Partage des bonnes pratiques'}
                  </h4>
                  <p className="text-sm text-white/60">
                    {extra.feature1_desc || 'Collaboration nationale entre places financières régionales'}
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#D4AF37] rounded flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-inter font-medium mb-1">
                    {extra.feature2_title || 'Ancrage territorial'}
                  </h4>
                  <p className="text-sm text-white/60">
                    {extra.feature2_desc || 'Action renforcée pour le développement économique local'}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="bg-white/5 backdrop-blur-sm p-8 lg:p-12 border border-white/10">
              <div className="text-center">
                <div className="w-24 h-24 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="font-playfair text-3xl font-bold text-white">PF</span>
                </div>
                
                <h3 className="font-playfair text-2xl font-semibold mb-2">
                  {extra.card_title_line1 || 'Réseau des Places'}
                </h3>
                <h3 className="font-playfair text-2xl font-semibold mb-6">
                  {extra.card_title_line2 || 'Financières de France'}
                </h3>
                
                <div className="w-16 h-0.5 bg-[#D4AF37] mx-auto mb-6" />
                
                <p className="text-white/70 font-inter text-sm mb-8">
                  {extra.card_description || 'Les places financières régionales réunies pour le développement économique des territoires français.'}
                </p>

                {/* Map dots representing cities */}
                <div className="flex justify-center gap-2 flex-wrap">
                  {cities.map((city, idx) => (
                    <span
                      key={city}
                      className={`px-3 py-1 text-xs font-inter rounded-full ${
                        city === 'Dijon'
                          ? 'bg-[#D4AF37] text-white'
                          : 'bg-white/10 text-white/70'
                      }`}
                    >
                      {city}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Decorative corner */}
            <div className="absolute -top-4 -right-4 w-8 h-8 border-t-4 border-r-4 border-[#D4AF37]" />
            <div className="absolute -bottom-4 -left-4 w-8 h-8 border-b-4 border-l-4 border-[#D4AF37]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NetworkSection;
